/**
 * @param form {HTMLFormElement}
 * @return {void}
 */
module.exports = function disableSubmitButtonInForm(form) {
    form.querySelectorAll('button[type="submit"]').forEach(button => {
        if (button instanceof HTMLButtonElement) {
            button.disabled = true;
        }
    });
};